import { styled } from 'baseui'
import { FlexCenterY } from '@/shared/theme/styled-components'

export const Stack = styled(FlexCenterY, {
  flexDirection: 'row',
  gap: '0.75rem',
})

export const HeaderRow = styled('div', {
  marginBottom: '1rem',
})

export const ProviderInfo = styled('div', ({ $theme }) => ({
  marginBottom: '1rem',
  fontSize: '16px',
  color: $theme.colors.primaryAlt,
}))

export const FileRow = styled('div', {
  marginBottom: '0.75rem',
})

export const FileLabel = styled('span', ({ $theme }) => ({
  display: 'inline-block',
  padding: '8px 16px',
  backgroundColor: $theme.colors.backgroundTertiary || $theme.colors.bgFallback,
  borderRadius: '4px',
  cursor: 'pointer',
  fontSize: '14px',
  ':hover': {
    backgroundColor: $theme.colors.backgroundSecondary || $theme.colors.borderFallback,
  },
}))

export const FileName = styled('span', ({ $theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.5rem',
  fontSize: '14px',
  color: $theme.colors.primaryAlt,
}))

export const ClearFileButton = styled('button', ({ $theme }) => ({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  fontSize: '18px',
  color: $theme.colors.textSubtle,
  padding: '0 4px',
  lineHeight: 1,
  ':hover': {
    color: $theme.colors.primaryAlt,
  },
}))

export const ActionsRow = styled('div', {
  marginTop: '0.75rem',
})

export const NotificationsWrapper = styled('div', {
  marginTop: '0.75rem',
})

export const SideBySideRow = styled('div', {
  display: 'flex',
  gap: '2rem',
  alignItems: 'flex-start',
})

export const SideBySideColumn = styled('div', {
  flex: '1 1 0',
  minWidth: 0,
})
